<template>
  <div>
    <div class="container relative-position" style="min-height: 95vh">
      <div v-if="resource && loaded">
        <div class="page-tool-bar">
          <div class="text-center">
            <q-btn
              @click="$router.push(`${$store.state[resource].clientRoute}/add`)"
              label="Add New Record"
              color="secondary"
              size="md"
              icon="add"
              class="no-shadow on-left"
              v-if="!readonly"
            ></q-btn>
            <q-btn round small flat :color="trashed ? 'info' : ''" @click="toggleTrashed()">
              <q-tooltip>Show / Hide deleted records</q-tooltip>
              <q-icon name="delete_sweep"></q-icon>
            </q-btn>
            <q-btn
              round
              small
              flat
              :color="getColor(unapproved)"
              @click="toggleUnapproved()"
              v-if="resource.trim() === 'person' || resource === 'address' || resource === 'company'"
            >
              <q-tooltip>Show / Hide records pending approval</q-tooltip>
              <q-icon name="playlist_add_check"></q-icon>
            </q-btn>
            <q-btn
              round
              small
              flat
              :color="getColor(guest)"
              @click="toggleGuest()"
              v-if="resource.trim() === 'person' || resource === 'company'"
            >
              <q-tooltip>Show / Hide guest records</q-tooltip>
              <q-icon name="help"></q-icon>
            </q-btn>
            <q-btn flat small round @click="handleRefresh">
              <q-tooltip>Refresh / Reset Saved Settings</q-tooltip>
              <q-icon name="refresh" color="secondary"></q-icon>
            </q-btn>
            <!-- <q-btn
              round small flat :color="layout === 'table' ? 'info' : ''" @click="handleSwitchLayout('table')"
            >
              <q-tooltip>
                Table Layout
              </q-tooltip>
              <q-icon name="grid_on"></q-icon>
            </q-btn>-->
            <!-- <q-btn
              round small flat :color="layout === 'cards' ? 'info' : ''" @click="handleSwitchLayout('cards')"
            >
              <q-tooltip>
                Card Layout
              </q-tooltip>
              <q-icon name="view_comfy"></q-icon>
            </q-btn>
            <q-btn
              round small flat :color="layout === 'accordion' ? 'info' : ''" @click="handleSwitchLayout('accordion')"
            >
              <q-tooltip>
                Group Layout
              </q-tooltip>
              <q-icon name="view_headline"></q-icon>
            </q-btn>
            <q-btn
              class="on-left" flat small round :color="azOpen ? 'info' : ''" @click="azOpen = !azOpen"
            >
              <q-tooltip>
                Show Alphabet Filters
              </q-tooltip>
              <q-icon name="sort_by_alpha" />
            </q-btn>-->
          </div>
          <az-bar :resource="resource" v-if="azOpen"></az-bar>
        </div>
        <div
          class="page-tool-bar bg-negative q-pa-sm text-white text-center"
          v-if="trashed"
        >Viewing Deleted Records</div>
        <div
          class="page-tool-bar bg-info q-pa-sm text-white text-center"
          v-if="unapproved === 'only'"
        >Viewing Records Pending Approval</div>
        <div
          class="page-tool-bar bg-warning q-pa-sm text-white text-center"
          v-if="unapproved === 'both'"
        >Viewing Both Approved and Unapproved Records</div>
        <div
          class="page-tool-bar bg-info q-pa-sm text-white text-center"
          v-if="guest === 'only'"
        >Viewing Guest Records (from event registrations)</div>
        <div
          class="page-tool-bar bg-warning q-pa-sm text-white text-center"
          v-if="guest === 'both'"
        >Viewing Both Guest and Member Records</div>
        <component :resource="resource" :is="listLayout" :trashed="trashed" :readonly="readonly"></component>
      </div>
      <div class="row">
        <div class="col-12">
          <q-pagination
            class="text-center justify-center"
            :value="storePagination.page"
            color="secondary"
            :min="1"
            :max="maxPage"
            :max-pages="15"
            boundary-numbers
            boundary-links
            @change="changePage"
          />
        </div>
      </div>
      <q-inner-loading :visible="!loaded"/>
    </div>
    <q-modal
      :value="!!quickEditId"
      content-classes="q-pa-lg"
      content-css="min-width: 70%"
      @close="handleCancel"
    >
      <div class="row q-pb-md">
        <div class="col-12">
          <span class="text-primary q-title">Quick Edit</span>
        </div>
      </div>
      <base-form v-if="quickEditId" :resource="resource" :id="quickEditId" :callback="handleSave">
        <span slot="goback">
          <div class="q-pa-lg q-mb-lg">
            <q-btn flat label="Cancel & Close Window" icon="close" @click="handleCancel"></q-btn>
          </div>
        </span>
      </base-form>
    </q-modal>
  </div>
</template>
<script>
  // import * as shvl from 'shvl'
  // import exportCSVFile from '../../utils/csv'
  import {extend} from 'quasar'

  export default {
  name: 'BaseList',
  props: {
    actionComponent: {
      type: String
    },
    resourcePassed: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      loaded: false,
      loading: true,
      ready: false,
      isModalOpen: false,
      selectedColumnsAction: null,
      selectedColumnsValue: null,
      filter: '',
      resource: '',
      trashed: false,
      unapproved: 'without',
      guest: 'without',
      tmpPaginate: {}
    }
  },
  methods: {
    handleRefresh () {
      this.$store.commit(`${this.resource}/FILTERS_CLEAR`)
      this.request({
        pagination: this.storePagination,
        filter: ''
      })
    },
    handleCancel () {
      this.$store.commit(`${this.resource}/SET_QUICK_EDIT`, null)
      this.isModalOpen = false
    },
    async handleSave () {
      this.loading = true
      try {
        await this.$store.dispatch(`${this.resource}/fetchOne`, { client: this.$axios, id: this.quickEditId })
      } catch (e) {
        this.loading = false
      }
      this.$store.commit(`${this.resource}/SET_QUICK_EDIT`, null)
      this.isModalOpen = false
      this.$q.notify({
        message: 'Quick edit data saved',
        type: 'positive'
      })
    },
    handleQuickEdit (id) {
      this.$store.commit(`${this.resource}/SET_QUICK_EDIT`, id)
      this.isModalOpen = true
    },
    handleSwitchLayout (payload) {
      this.layout = payload
    },
    async toggleTrashed () {
      // add filter removalDate ne null
      this.trashed = !this.trashed
      this.updateSettings()
    },
    async toggleUnapproved () {
      // add filter removalDate ne null
      // this.unapproved = !this.unapproved
      if (this.unapproved === 'both') {
        this.unapproved = 'without'
      } else if (this.unapproved === 'without') {
        this.unapproved = 'only'
      } else if (this.unapproved === 'only') {
        this.unapproved = 'both'
      } else {
        this.unapproved = 'without'
      }
      this.updateSettings()
    },
    async toggleGuest () {
      // add filter removalDate ne null
      // this.guest = !this.guest
      if (this.guest === 'both') {
        this.guest = 'without'
        // this.unapproved = 'without'
      } else if (this.guest === 'without') {
        this.guest = 'only'
        // this.unapproved = 'both'
      } else if (this.guest === 'only') {
        this.guest = 'both'
        // this.unapproved = 'both'
      } else {
        this.guest = 'without'
        // this.unapproved = 'without'
      }
      this.updateSettings()
    },
    getColor (val) {
      // // console.log('val', val)
      if (val === 'only') {
        return 'info'
      }
      if (val === 'both') {
        return 'warning'
      }
    },
    async updateSettings () {
      // this.changePage(1)
      // // console.log('updateSettings')
      // -- also de-select since we are moving views
      this.$store.commit(`${this.resource}/UNAPPROVED_DATA`, this.unapproved)
      this.$store.commit(`${this.resource}/GUEST_DATA`, this.guest)
      this.$store.commit(`${this.resource}/SET_SETTING`, {
        field: 'selected',
        value: []
      })
      this.$nextTick(() => {
        this.request({
          pagination: this.storePagination
        })
      })
    },
    async request ({ pagination = {} }) {
      // console.log('request pagination', pagination)
      this.loading = true
      try {
        await this.$store.dispatch(`${this.resource}/paginate`, {
          client: this.$axios,
          pagination,
          trashed: this.trashed ? 1 : null
        })
        this.loading = false
        return Promise.resolve()
      } catch (e) {
        this.loading = false
        return Promise.resolve()
      }
    },
    async changePage (page) {
      // console.log('changePage', page)
      const pagination = extend(true, this.storePagination, { page })
      await this.request({ pagination })
    }
  },
  computed: {
    quickEditId () {
      return this.$store.state[this.resource].quickEditId || null
    },
    listLayout () {
      switch (this.layout) {
        case 'cards':
          return 'layout-cards'
        case 'accordion':
          return 'layout-accordion'
        default:
          return 'layout-table'
      }
    },
    maxPage () {
      return Math.ceil(this.storePagination.rowsNumber / this.storePagination.rowsPerPage || 1)
    },
    clientRoute () {
      return this.$store.state[this.resource].clientRoute
    },
    selectedRows () {
      return this.$store.getters[`${this.resource}/selectedRows`]
    },
    storePagination: {
      get () {
        return this.$store.state[this.resource].settings.pagination
      },
      set (p) {
        this.$store.commit(`${this.resource}/SET_PAGINATION`, p)
      }
    },
    azOpen: {
      get () {
        return this.$store.state[this.resource].settings.azOpen
      },
      set (val) {
        this.$store.commit(`${this.resource}/SET_SETTING`, {
          field: 'azOpen',
          value: val
        })
      }
    },
    layout: {
      get () {
        return this.$store.state[this.resource].settings.layout || 'table'
      },
      set (val) {
        this.$store.commit(`${this.resource}/SET_SETTING`, {
          field: 'layout',
          value: val
        })
      }
    }
  },
  async created () {
    if (this.resourcePassed) {
      this.resource = this.resourcePassed
    } else {
      this.resource = this.$route.meta.resource
    }
    this.$store.commit(`${this.resource}/GUEST_DATA`, this.guest)
    this.$store.commit(`${this.resource}/UNAPPROVED_DATA`, this.unapproved)
    if (this.$store && this.$store.state && this.$store.state[this.resource] && this.$store.state[this.resource].defaultFilter) {
      // console.log('this.$store.state[this.resource].defaultFilter', this.$store.state[this.resource].defaultFilter)
      for (let filter of this.$store.state[this.resource].defaultFilter) {
        // console.log('filter', filter)
        if (filter.key && filter.value) {
          this.$store.commit(`${this.resource}/SET_COLUMN_FILTER`, {
            field: filter.key,
            value: filter.value
          })
        }
      }
    }
  },
  async mounted () {
    // // console.log('this.$store.state[this.resource].defaultFilter', this.$store.state[this.resource].defaultFilter)
    // once mounted, we need to trigger the initial server data fetch
    await this.request({
      pagination: this.storePagination
    })
    this.$nextTick(() => {
      this.loaded = true
      this.ready = true
    })
  }
}
</script>
